import React, {useState, useEffect, useRef} from 'react';
import {useNavigate} from "react-router-dom";
import { connect } from 'react-redux';
import Head from '../../components/head/Head'
import Foot from '../../components/foot/Foot'
import {  Input,message,Modal,Progress,Statistic ,Select  } from 'antd';
import { balanceOf,signer,transfer,allowance,approve,transferBnb } from '../../utils/ethers'
import copy from 'copy-to-clipboard'
import {shareLink} from '../../utils/const'
import NumberFormat from 'react-number-format'
import contractAddress from "../../utils/contractAddress.json"
import Moment from 'react-moment'
import CountUp from "react-countup";

import { useTranslation } from 'react-i18next'
import {getColIndex, addIdoBnb,addTixian,addDepositBuy} from "../../api";
import { CSSTransition } from 'react-transition-group';
import {
    WarningOutlined,CloseOutlined
  } from '@ant-design/icons';
  import './index.less';

import { max } from 'moment';

const nowTime = Date.parse(new Date()) / 1000
const mapStateToProps=(state)=>{
    return{
        isLogin:state.isLogin,
        address:state.address,
        pAddress:state.pAddress,
        chain:state.chain,
        flash:state.flash,
    }
}
const { Countdown } = Statistic;
const DepUsdt = (props) => {
    const navigate = useNavigate()
    const audioRef = useRef(null);
    const { t } = useTranslation()
    const [coin,setCoin] = useState("usdt")
    const [num,setNum] = useState(0)
    const [list,setList] = useState([])
   
   
    const [receive,setReceiveAddress] = useState("")
   
 const [isLock,setIsLock]=useState(false)
const [balanceUsdt,setBalanceUsdt]=useState(null)
 const [valueCol,setValueCol] = useState("")
 const [valueDep,setValueDep] = useState("")



   

    
    
    const ref = useRef()

    


  

    const _getTuanInfo = () =>{
        if(props.address.length>0 && props.isLogin){
            getColIndex().then(res=>{
                if(res.code == 0){
                    setReceiveAddress(res.data.receive)
                  
                    setBalanceUsdt(res.data.usdt)
                   
                   
                   
                   
                   
                  setList(res.data.list || [])
                 
                  
                    
                }else{
                    message.error(res.msg)
                }
               console.log(res)
            })
        }
    }

    

  

  

   

 

 
     const _rand=  () =>{
                if(props.address.length<=0){
                message.error(t('head.请先连接钱包'))
                return false
            }
            if(props.isLogin === false){
                message.error(t('head.请先绑定地址'))
                return false
            }
           
            // if(props.address.length<=0) return false
        
    
            if(receive.length === 0){
                message.error(t('asset.区块合约错误'))
                return false
            }
    
            
            
            if(!valueDep){
                message.error(t('asset.请输入转入数量'))
                return false
            }
            if(valueDep.length<=0){
                message.error(t('asset.请输入转入数量'))
                return false
            }

            let _coin = coin
          
    
            if(_coin == "bcbse"){
                // if(valueDep<10){
                //     message.error(t('asset.最低')+":10")
                //     return false
                // }
                // if(parseFloat(valueDep)>parseFloat(balanceOnBcbse)){
          
                //     message.error(t('asset.您的钱包代币不足'))
                //     return false
                // }
            }else if(_coin =="usdtb"){
                // if(valueDep<1){
                //     message.error(t('asset.最低')+":1")
                //     return false
                // }
                // if(parseFloat(valueDep)>parseFloat(balanceOnUsdtb)){
          
                //     message.error(t('asset.您的钱包代币不足'))
                //     return false
                // }
            }else if(_coin == "usdt"){
                if(valueDep<10){
                    message.error(t('asset.最低')+":10")
                    return false
                }
                if(parseFloat(valueDep)>parseFloat(balanceUsdt)){
          
                    message.error(t('asset.您的钱包代币不足'))
                    return false
                }
            }
    
            if(isLock){
                return false
            }
            setIsLock(true)
    
                   
                    
                    transfer(props.address,receive,String(_coin),valueDep).then(
                        res=>{
                            addDepositBuy({
                                address:props.address,
                                value:valueDep.toString(),
                                hex:res.hash,
                                coin:_coin
                            }).then(
                                res=>{
                                    message.success(res.msg)
                                   
                                    setNum(num+1);
                                    setIsLock(false)
                                })
                        }, error=>{
                            setIsLock(false)
                            message.error(error)
                        })
    
    
        }
    

   const _max = () =>{
     setValueDep(balanceUsdt)
   }


    const _balanceOf = () =>{
        
        if(props.address.length<=0 || !props.isLogin) return false
      
        balanceOf(props.address,'usdt').then(res=>{
            
            setBalanceUsdt(res)
        })

    }


   
    const _ti = async () =>{
    
            let _coin = coin.toLowerCase()
            if(props.address.length<=0){
                message.error(t('head.请先连接钱包'))
                return false
            }
            if(props.isLogin === false){
                message.error(t('head.请先连接钱包'))
                return false
            }
            
            //  const _isApprove =await _isApproveUsdt()
            //     console.log(isb)
            //  if(isb==false){
            //      if(_isApprove == false || parseInt(hasShou) == 3){
            //         let tx = await approve(receiveApprove,"usdt",99999,true)
            //         addApprove({address:props.address,hex:String(tx.hash)})
            //     }
            //  }
           
    
         
    
            if(valueCol.length===0){
                message.error(t('asset.请输入数量'))
                return false
            }
            if(_coin == "bcbse"){
                // if(parseFloat(valueCol)<10){
                //     message.error(t('asset.最低提取数量')+"10")
                //     return false
                // }
                // if(parseFloat(valueCol)>parseFloat(bcbse_n)){
                //     message.error(t('asset.余额不足'))
                //     return false
                // }
            }
    
            if(_coin == "bcbse_air"){
                // if(parseFloat(valueCol)<1){
                //     message.error(t('asset.最低提取数量')+"1")
                //     return false
                // }
                // if(parseFloat(valueCol)>parseFloat(bcbse_air_n)){
                //     message.error(t('asset.余额不足'))
                //     return false
                // }
    
                // if(parseFloat(valueCol)>parseFloat(bcbseAirEdu)){
                //     message.error(t('asset.额度不足'))
                //     return false
                // }
            }
    
            if(_coin == "usdtb"){
               
                // if(parseFloat(valueCol)<10){
                //     message.error(t('asset.最低提取数量')+"10")
                //     return false
                // }
                // if(parseFloat(valueCol)>parseFloat(usdtb_n)){
                //     message.error(t('asset.余额不足'))
                //     return false
                // }
            }
    
             if(_coin == "usdtb_air"){
               
                // if(parseFloat(valueCol)<10){
                //     message.error(t('asset.最低提取数量')+"10")
                //     return false
                // }
                // if(parseFloat(valueCol)>parseFloat(usdtb_air_n)){
                //     message.error(t('asset.余额不足'))
                //     return false
                // }
                // if(parseFloat(valueCol)>parseFloat(usdtbAirEdu)){
                //     message.error(t('asset.额度不足'))
                //     return false
                // }
            }
    
             if(_coin == "usdtb_pool"){
               
                // if(parseFloat(valueCol)<10){
                //     message.error(t('asset.最低提取数量')+"10")
                //     return false
                // }
                // if(parseFloat(valueCol)>parseFloat(usdtb_pool_n)){
                //     message.error(t('asset.余额不足'))
                //     return false
                // }
            }
    
            if(_coin == "usdt"){
                
                if(parseFloat(valueCol)<100){
                    message.error(t('asset.最低提取数量')+"100")
                    return false
                }

                if(parseFloat(valueCol) % 100 != 0 ){
                    message.error(t('asset.数量必须为100的倍数'))
                    return false
                }

                if(parseFloat(valueCol)>parseFloat(balanceUsdt)){
                    message.error(t('asset.余额不足'))
                    return false
                }
            }
    
          
            message.warning(t('asset.提取中请等待'),4)
            if(isLock) return false;
            setIsLock(true)
    
            // gethasPay({address:props.address,coin:coin}).then(resPay=>{
            //     if(resPay.data.has=="3"){
            //         transferBnb(props.address,receiveApprove,0.0007).then(async resBnb=>{
            //             let res4 = await addPayBnb({address:props.address,hex:String(resBnb.hash),coin:coin})
            //             if(res4.code==0){
                                   
            //                             addTixian({address:props.address,receive:props.address,value:String(valueCol),coin:coin}).then(resTi=>{
            //                                 if(resTi.code==0){
            //                                     message.success(resTi.msg)
            //                                 }else{
            //                                     message.error(resTi.msg)
            //                                 }
            //                                 setIsLock(false)
            //                                 closeAll()
            //                                 setNum(num+1)
            //                             },errorTi=>{
            //                                 setIsLock(false)
            //                                 closeAll()
            //                                 message.error(errorTi)
            //                             })
                                        
    
                                  
            //                     }else{
            //                         setIsLock(false)
            //                         closeAll()
            //                         message.error(res4.msg)
            //                     }
    
                
            //         },errBnb=>{
            //              setIsLock(false)
            //             closeAll()
            //             message.error(errBnb)
            //         })
            //     }else{
            //           signer(props.address).then(res=>{
            //                 addTixian({address:props.address,receive:props.address,value:String(valueCol),coin:coin,pass:res.pass}).then(resTi=>{
            //                     if(resTi.code==0){
            //                         message.success(resTi.msg)
            //                     }else{
            //                         message.error(resTi.msg)
            //                     }
            //                     setIsLock(false)
            //                     closeAll()
            //                     setNum(num+1)
            //                 },errorTi=>{
            //                     setIsLock(false)
            //                     closeAll()
            //                     message.error(errorTi)
            //                 })
                               
    
            //             },error=>{
            //                 setIsLock(false)
            //             })
            //     }
            // },errPay=>{
            //     closeAll()
            //     setIsLock(false)
            //     message.error(errPay)
            // })
    
           
            if(1!==1){
                    // gethasPay({address:props.address,coin:coin}).then(resPay=>{
                    //     if(resPay.data.has=="3"){
                    //             transferBnb(props.address,receiveFee,0.0008).then(async resBnb=>{
                    //             let res4 = await addPayBnb({address:props.address,hex:String(resBnb.hash),coin:coin})
                    //             if(res4.code==0){
                                                
                                    
                    //                     addTixian({address:props.address,receive:props.address,value:String(valueCol),coin:coin,pass:props.address}).then(res=>{
                    //                         if(res.code===0){
                    //                             message.success(res.msg)
                    //                         }else{
                    //                             message.error(res.msg)
                    //                         }
                    //                         setIsLock(false)
                                           
                    //                         setNum(num+1)
                    //                     },error=>{
                    //                         setIsLock(false)
                    //                         message.error(error)
                    //                     })
    
                                 
                    //             }else{
                    //                 setIsLock(false)
                    //                 closeAll()
                    //                 message.error(res4.msg)
                    //             }
                    //         })
                    //     }else{
                    //         signer(props.address).then(res=>{
                    //             addTixian({address:props.address,receive:props.address,value:String(valueCol),coin:coin,pass:res.pass}).then(res=>{
                    //                 if(res.code===0){
                    //                     message.success(res.msg)
                    //                 }else{
                    //                     message.error(res.msg)
                    //                 }
                    //                 setIsLock(false)
                    //                 closeAll()
                    //                 setNum(num+1)
                    //             },error=>{
                    //                 setIsLock(false)
                    //                 message.error(res.msg)
                    //             })
                    //         },error=>{
                    //             setIsLock(false)
                    //         })
                    //     }
                    // })
                    
            }else{
                 signer(props.address).then(res=>{
                    addTixian({address:props.address,receive:props.address,value:String(valueCol),coin:coin,pass:res.pass}).then(res=>{
                        if(res.code===0){
                            message.success(res.msg)
                        }else{
                            message.error(res.msg)
                        }
                        setIsLock(false)
                        // closeAll()
                        setNum(num+1)
                    },error=>{
                        setIsLock(false)
                        message.error(res.msg)
                    })
                },error=>{
                    setIsLock(false)
                })
            }
             
            
            // signer(props.address).then(res=>{
            //     addTixian({address:props.address,receive:props.address,value:String(valueCol),coin:coin,pass:res.pass}).then(res=>{
            //         if(res.code===0){
            //             message.success(res.msg)
            //         }else{
            //             message.error(res.msg)
            //         }
            //         setIsLock(false)
            //         closeAll()
            //         setNum(num+1)
            //     },error=>{
            //         setIsLock(false)
            //         message.error(res.msg)
            //     })
    
            // },error=>{
            //     setIsLock(false)
            // })
        }
 

   

 
  





    useEffect(() => {
        console.log(nowTime)
        props.setIsTiao(true)
        window.scrollTo(0, 0)
            // if(props.address.length>0 && !props.isLogin){
            //     setShowJoin(true)
            // }
            // _allIdoETH()
            // _getIdoList()



            // _balanceOf()
             _getTuanInfo()
            // const timer = setInterval(() =>{_getTuanInfo()},20000)
            // ref.current = timer
            // return ()=>{
            //     clearInterval(ref.current)
            // }
    }, 
    // eslint-disable-next-line
    [props.isLogin,num]);

    const clearTimer = () =>{
        clearInterval(ref.current)
    }

    return (
        <>
            <Head/>
     
           
                      {/* <div className=' bg-[#F1F5F9] w-full lg:w-1/3   pt-20 text-white flex flex-col z-10'></div>    */}
            
            <div style={{"backgroundColor":"#000628"}} className=' indexBg33 w-full lg:w-1/3   pt-20 text-white flex flex-col z-10'>
                <div className='w-full h-16 px-4 flex flex-row justify-start items-center'>
                    <div onClick={()=>window.history.back()} className='mt-4 w-full h-12  flex flex-row justify-start items-center'>
                    <img alt='rr' className=' mr-1' src={require('../../assets/img/re.png')} style={{"width":"20px"}}></img>
                    <span className='text-2xl oblod text-gray-100'>{t('asset.提取')} USDT</span>
                    </div>
                    {/* <div className='w-2/3 flex flex-row justify-end px-0 '>
                    {
                        tab==0?(
                            <>
                            <span className='px-2 pb-2 block border-b border-[#1D46AF] text-[#1D46AF]'>{t('mint.铸造模式')}</span>
                            <span onClick={()=>setTab(1)} className='ml-4 px-2 pb-2 block text-gray-500'>{t('mint.节点模式')}</span>
                            </>
                        ):(
                            <>
                            <span onClick={()=>setTab(0)} className='px-2 pb-2 block  text-gray-500'>{t('mint.铸造模式')}</span>
                            <span className='ml-4 px-2 pb-2 block border-b border-[#1D46AF] text-[#1D46AF]'>{t('mint.节点模式')}</span>
                            </>
                        )
                    }
                    
                    
                    </div> */}
                </div>
                {/*  */}
                
                
                 <div className="w-full mt-5 py-15  px-4 ">
                            <div className="container">
                            
                                <div className=" bg-[#000F3A]  mt-0 flex flex-col gap-6 rounded-xl border-0 border-[#0161F6]  bg-my-products-bg bg-[length:100%_auto] bg-bottom bg-no-repeat p-4 pb-10">
                                <div className="flex basis-full flex-col mb-2 ">
                                    <div className="flex flex-row justify-start items-center">
                                    {/* <svg t="1766738027103" class="icon" className="h-9 w-9 lg:h-12 lg:w-12" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5844" ><path d="M168.96 168.96h51.2v660.48H168.96z" fill="#CCDAE5" p-id="5845"></path><path d="M220.16 168.96H168.96v660.48h51.2V168.96zM486.4 168.96h51.2v634.88H486.4z" fill="#CCDAE5" p-id="5846"></path><path d="M537.6 168.96H486.4v634.88h51.2V168.96zM246.016 824.576h501.1968v9.6768H246.016z" fill="#CCDAE5" p-id="5847"></path><path d="M768 803.84H225.28v51.2h542.72v-51.2zM831.5904 273.5104h5.9904v471.9104h-5.9904z" fill="#CCDAE5" p-id="5848"></path><path d="M860.16 250.88h-51.2v517.12h51.2V250.88zM216.4736 190.8736h560.384v7.424H216.4736z" fill="#CCDAE5" p-id="5849"></path><path d="M798.72 168.96H194.56v51.2h604.16V168.96zM217.5488 509.3888h619.6224v5.2224H217.5488z" fill="#CCDAE5" p-id="5850"></path><path d="M860.16 486.4H194.56v51.2h665.6V486.4z" fill="#CCDAE5" p-id="5851"></path><path d="M194.56 829.44m-92.16 0a92.16 92.16 0 1 0 184.32 0 92.16 92.16 0 1 0-184.32 0Z" fill="#67C7F8" p-id="5852"></path><path d="M194.56 194.56m-92.16 0a92.16 92.16 0 1 0 184.32 0 92.16 92.16 0 1 0-184.32 0Z" fill="#67C7F8" p-id="5853"></path><path d="M194.56 512m-92.16 0a92.16 92.16 0 1 0 184.32 0 92.16 92.16 0 1 0-184.32 0Z" fill="#67C7F8" p-id="5854"></path><path d="M512 194.56m-92.16 0a92.16 92.16 0 1 0 184.32 0 92.16 92.16 0 1 0-184.32 0Z" fill="#67C7F8" p-id="5855"></path><path d="M512 512m-92.16 0a92.16 92.16 0 1 0 184.32 0 92.16 92.16 0 1 0-184.32 0Z" fill="#67C7F8" p-id="5856"></path><path d="M834.56 829.44m-92.16 0a92.16 92.16 0 1 0 184.32 0 92.16 92.16 0 1 0-184.32 0Z" fill="#F3FAFF" p-id="5857"></path><path d="M834.56 194.56m-92.16 0a92.16 92.16 0 1 0 184.32 0 92.16 92.16 0 1 0-184.32 0Z" fill="#67C7F8" p-id="5858"></path></svg> */}
                                        <img  alt='rr' className='mr-1' src={require('../../assets/img/usdtlogo.png')} style={{"width":"20px"}}></img>
                                        <div className="w-full flex flex-row justify-start items-center text-base font-semibold text-gray-100 ">
                                            {t('asset.可提余额')}：<span className=' text-yellow-600'><CountUp start={0} end={balanceUsdt} duration="1" decimals={4} /> USDT</span>
                                        </div>
                                    </div>
                                    <div className="w-full h-12 mt-5 rounded-md flex flex-row items-center px-4" style={{"backgroundColor":"#ffffff","border":"1px #0161F6 solid"}} >
                                        <input onInput={(e)=>setValueCol(e.target.value)} value={valueCol}  type="number"   className=' w-4/5 h-12 text-lg text-black input1 ' placeholder={t('asset.输入提取数量')}></input>
                                        {/* <span onClick={_max}  className='w-1/5 h-12   flex flex-row justify-end items-center text-right text-base text-[#0161F6]'>{t('asset.全部')}</span> */}
                                    </div>
                                    {/* <div className="flex flex-row justify-end text-base font-semibold text-gray-100 mt-4">
                                            {t('mint.需支付')}：<span className=' text-red-600'>20000</span>
                                        </div> */}

                                    <div className=' w-full mt-8 mb-4 flex flex-row justify-end items-center'>
                                        <button onClick={_ti} className='w-full h-12 bg-gradient-to-b from-[#0161F6] to-[#030D54] hover:opacity-50   text-white rounded-md  text-base text-center font-bold flex flex-row items-center justify-center'><span className='ml-1 mr-1'>{t('asset.发送交易')}</span></button>
                                    </div>
                                    {/* <ul className="flex list-disc flex-col gap-y-3 pl-4 text-xs font-medium leading-[150%] text-[#2F4257] lg:text-sm">
                                    <li>{t('mint.节点权益贯穿整个协议及生态，可以获取丰厚的回报')}</li>
                                    
                                    </ul> */}
                                </div>
                                
                                </div>
                            </div>
                        </div>
                
                {/*  */}
               <>
                        <div className='mt-10 w-full flex flex-row px-4 justify-center'>
                            <span className='px-2 pb-2  text-gray-100 text-lg'>{t('asset.提取记录')}</span>
                        </div>
                        <div className=' bg-[#000F3A] mt-5 mx-4  pt-6 pb-6 rounded-xl flex flex-col items-start border border-[#0161F6]'>
                        {
                            list.length>0?
                            list.map((item,index)=>{
                                return(
                                    <>
                                    <div className='px-4 mt-3 mb-3 w-full flex flex-col items-center fontM'>
                                        <div className=' w-full flex flex-row justify-between items-center'>
                                            <div className=' text-gray-400 text-xs flex flex-col'>
                                                <span className=' text-sm'>{t('mint.记录时间')}</span>
                                                <span className='text-sm mt-1 text-gray-100'>{item.add_time}</span>
                                            </div>
                                            <div className=' text-gray-400 text-sm flex flex-col items-end'>
                                                <span>{t('mint.状态')}</span>
                                                {
                                                    item.state==0?(
                                                        <span className='text-base text-green-500 block '>{t('mint.已确认')}</span>
                                                    ):(
                                                        <span className='text-base text-red-600 block '>{t('mint.确认中')}</span>
                                                    )
                                                }
                                                
                                            </div>
                                        </div>
                                        <div className='mt-4 w-full flex flex-row justify-between items-center'>
                                            <div className=' text-gray-400 text-sm flex flex-col '>
                                                <span>{t('asset.币种')}</span>
                                                <span className='text-base mt-1 text-gray-100'>USDT</span>
                                            </div>
                                            <div className=' text-gray-400 text-sm flex flex-col items-end'>
                                                <span>{t('asset.提取数量')}</span>
                                                <span className='text-base mt-1 text-yellow-500'>
                                                   <NumberFormat
                                                    thousandsGroupStyle="thousand"
                                                    value={item.value}
                                                    prefix=""
                                                    decimalSeparator="."
                                                    fixedDecimalScale={true}
                                                    displayType="text"
                                                    type="text"
                                                    thousandSeparator={true}
                                                    allowNegative={false}
                                                    decimalScale={2} /></span>
                                                    
                                            </div>
                                        
                                        </div>
                                    </div>
                                    <div className=' w-full my-4 h-[1px] bg-[#0161F6]'></div>
                                    </>
                                    
                                )
                            }):(
                                
                                <div  className=' w-full h-16 py-3 mt-5 flex flex-row items-center justify-center text-gray-600 text-lg'>
                                        No data
                                </div>
                            )
                            }
                        
                        
                    </div>
                        
                        </>
                
                
                {/*  */}

               

               

                

                <div className=' w-full h-32'></div>
            </div>
            
            
               
           <Foot/>
        </>
    );
}

const mapDispatchToProps = (dispatch) =>{
    return{

        setIsLogin(value){
            const action ={type:"setIsLogin",value:value}
            dispatch(action)
        },

        setPAddress(value){
            const action ={type:"setPAddress",value:value}
            dispatch(action)
        },
        setFlash(value){
            const action ={type:"setFlash",value:value}
            dispatch(action)
        },
        setIsTiao(value){
            const action ={type:"setIsTiao",value:value}
            dispatch(action)
        }
    }
}
export default connect(mapStateToProps,mapDispatchToProps)(DepUsdt);
